import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import JetfiAreas from '../views/JetfiAreas.vue'
import JetfiCountries from '../views/JetfiCountries.vue'
import JetfiProducts from '../views/JetfiProducts.vue'
import JetfiSelectSns from '../views/JetfiSelectSns.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    redirect: 'areas',
    children: [
      {
        path: '/areas',
        name: 'areas',
        component: JetfiAreas,
        meta: {
          title: process.env.VUE_APP_AREA_TITLE,
          keepAlive: true
        }
      },
      {
        path: '/countries',
        name: 'countries',
        component: JetfiCountries,
        meta: {
          title: process.env.VUE_APP_COUNTRY_TITLE,
          keepAlive: true
        }
      },
      {
        path: '/products',
        name: 'products',
        component: JetfiProducts,
        meta: {
          title: process.env.VUE_APP_PRODUCT_TITLE,
          keepAlive: true
        }
      },
      {
        path: '/select-ch',
        name: 'select-ch',
        component: JetfiSelectSns,
        meta: {
          title: process.env.VUE_APP_VPN_TITLE,
          keepAlive: true
        }
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const scrollBehavior = (to, from, savedPosition) => {
  // keep-alive 返回缓存页面后记录浏览位置
  if (savedPosition && to.meta.keepAlive) {
    return savedPosition;
  } else {
    // 异步滚动操作
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 1 });
      }, 0);
    });
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior
})

router.beforeEach((to, from, next) => {
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;
  if (to.query.gb_distributor) {
    to.query.d = to.query.gb_distributor;
  }
  if (to.query.gb_coupon) {
    to.query.c = to.query.gb_coupon;
  }
  // both t and d must be exist
  if (!to.query.t || !to.query.d) {
    to.query.t = to.query.t || process.env.VUE_APP_TYPE;
    to.query.d = to.query.d || process.env.VUE_APP_DISTRIBUTOR;
    next({ path: to.path, query: to.query });
  } else {
    next();
  }
});

export default router
